export const disabledDate18Plus = (current: any) => {
    // Calculate the date 18 years ago from today
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    
    // Disable dates before 18 years ago
    return current && current > eighteenYearsAgo;
  };

  export const disabledDateIfLesserThanGiveDate = (current: any, date: Date) => {
    // Disable dates before a given Date
    return current && current > date;
  };

  export const disabledDateIfLesserThanGivenNumberOfDays= (current: any, days: number) => {

      const daysAgo = new Date();
      daysAgo.setDate(daysAgo.getDate() + days);
      // Disable dates before a given Date
      return current && current < daysAgo;
  };